import React from 'react';
import { 
  BanknotesIcon, 
  CurrencyDollarIcon, 
  ArrowTrendingUpIcon, 
  ArrowTrendingDownIcon 
} from '@heroicons/react/24/outline';

// Currency colors
export const currencyColors = {
  BAI: {
    text: 'text-emerald-500',
    bg: 'bg-emerald-500',
    bgLight: 'bg-emerald-500/20',
    border: 'border-emerald-500/50',
    gradient: 'from-emerald-500 to-teal-500'
  },
  BNB: {
    text: 'text-yellow-500',
    bg: 'bg-yellow-500',
    bgLight: 'bg-yellow-500/20',
    border: 'border-yellow-500/50',
    gradient: 'from-yellow-500 to-amber-500'
  },
  IMX: {
    text: 'text-blue-500',
    bg: 'bg-blue-500',
    bgLight: 'bg-blue-500/20',
    border: 'border-blue-500/50',
    gradient: 'from-blue-500 to-indigo-500'
  },
  USDT: {
    text: 'text-green-500',
    bg: 'bg-green-500',
    bgLight: 'bg-green-500/20',
    border: 'border-green-500/50',
    gradient: 'from-green-500 to-emerald-500'
  }
};

// Size classes for icons
const sizeClasses = {
  xs: 'w-3 h-3',
  sm: 'w-4 h-4',
  md: 'w-6 h-6',
  lg: 'w-8 h-8',
  xl: 'w-10 h-10'
};

// Base currency icon component
const CurrencyIcon = ({ currency, size = 'md', className = '' }) => {
  const sizeClass = sizeClasses[size] || sizeClasses.md;
  const colorClass = currencyColors[currency]?.text || 'text-gray-400';
  
  return (
    <div className={`${sizeClass} ${colorClass} ${className}`}>
      {currency === 'BAI' && <BanknotesIcon className="w-full h-full" />}
      {currency === 'BNB' && <CurrencyDollarIcon className="w-full h-full" />}
      {currency === 'IMX' && <ArrowTrendingUpIcon className="w-full h-full" />}
      {currency === 'USDT' && <ArrowTrendingDownIcon className="w-full h-full" />}
    </div>
  );
};

// Individual currency icons
export const BAIIcon = (props) => <CurrencyIcon currency="BAI" {...props} />;
export const BNBIcon = (props) => <CurrencyIcon currency="BNB" {...props} />;
export const IMXIcon = (props) => <CurrencyIcon currency="IMX" {...props} />;
export const USDTIcon = (props) => <CurrencyIcon currency="USDT" {...props} />;

export default CurrencyIcon;
